// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__162FB","question":"styles_question__faQSG","description":"styles_description__2CPG7"};